import { ingestPdf } from "./pdfIngestion";
import { ingestDocx } from "./docxIngestion";

const MAX_FILE_BYTES = 10 * 1024 * 1024;
const PDF_MIME = "application/pdf";
const DOCX_MIME =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

/**
 * @param {File} file
 * @param {{ renderPdfImages?: boolean }} [options]
 * @returns {Promise<import("./types").IngestedDocument>}
 */
export async function ingestFile(file, options = {}) {
  const { renderPdfImages = true } = options;
  if (file.size > MAX_FILE_BYTES) {
    throw new Error("File exceeds the 10 MB limit.");
  }

  const arrayBuffer = await file.arrayBuffer();
  const type = file.type;
  const name = file.name.toLowerCase();

  if (type.startsWith("image/")) {
    return {
      pages: [{ pageNumber: 1, text: null, image: new Blob([arrayBuffer], { type }) }],
    };
  }

  if (type === PDF_MIME || name.endsWith(".pdf")) {
    return { pages: await ingestPdf(arrayBuffer, { renderImages: renderPdfImages }) };
  }

  if (type === DOCX_MIME || name.endsWith(".docx")) {
    const text = await ingestDocx(arrayBuffer);
    return { pages: [{ pageNumber: 1, text, image: null }] };
  }

  throw new Error(
    `Unsupported file type "${type || "unknown"}". Supported formats: PNG, JPG, WEBP, PDF, DOCX.`,
  );
}
